interface Env {
  ecomApiUrl: string;
  sdkLibraryUrl: string;
  sdkVersionToSriHash: Record<string, string>;
}

const getIdFromUrl = (): string | null => {
  return new URL(window.location.href).searchParams.get('id');
};

const isResume = (): boolean => {
  const returnValue = new URL(window.location.href).searchParams.get('resume');
  return returnValue === '1';
};

let envPromise: Promise<Env> | null = null;

const getEnv = (): Promise<Env> => {
  if (!envPromise) {
    const url = `${process.env.PUBLIC_URL ?? ''}/env`;
    envPromise = fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Failed to load env (status ${res.status})`);
        }
        return res.json() as Promise<Env>;
      })
      .catch((error) => {
        // Allow retrying on the next call if fetching failed.
        envPromise = null;
        throw error;
      });
  }
  return envPromise;
};

/**
 * Extracts the SDK version segment from the SDK library url.
 * e.g. `./1.8.0/sdk/js/paymenttools.js` -> `1.8.0`.
 * Returns `undefined` when the url does not contain a version segment.
 */
const getSdkVersionFromUrl = (sdkLibraryUrl: string): string | undefined => {
  const match = /(?:^|\/)(\d+(?:\.\d+)+)(?:\/|$)/.exec(sdkLibraryUrl);
  return match?.[1];
};

export { getIdFromUrl, getEnv, getSdkVersionFromUrl, isResume };
export type { Env };
